import { render } from "./FacultyMentoring&Commitment.vue?vue&type=template&id=7e71926d"
import script from "./FacultyMentoring&Commitment.vue?vue&type=script&lang=js"
export * from "./FacultyMentoring&Commitment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__